var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRtk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 10,
    viewBox: "0 0 26 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.932528 10V0.545454H4.47798C5.20431 0.545454 5.81368 0.671638 6.30611 0.924005C6.80161 1.17637 7.17554 1.5303 7.42791 1.98579C7.68336 2.43821 7.81108 2.96603 7.81108 3.56925C7.81108 4.17554 7.68182 4.70182 7.4233 5.14808C7.16785 5.59126 6.79084 5.93442 6.29226 6.17756C5.79368 6.41761 5.18123 6.53764 4.4549 6.53764H1.92969V5.11577H4.22408C4.64879 5.11577 4.99657 5.05729 5.2674 4.94034C5.53823 4.82031 5.73828 4.64642 5.86754 4.41868C5.99988 4.18785 6.06605 3.90471 6.06605 3.56925C6.06605 3.23378 5.99988 2.94756 5.86754 2.71058C5.7352 2.47053 5.53362 2.28894 5.26278 2.16584C4.99195 2.03965 4.64264 1.97656 4.21484 1.97656H2.64524V10H0.932528ZM5.81676 5.71591L8.15732 10H6.24609L3.94709 5.71591H5.81676ZM8.97212 1.98118V0.545454H16.5154V1.98118H13.5932V10H11.8944V1.98118H8.97212ZM17.9696 10V0.545454H19.6824V4.88956H19.7978L23.4863 0.545454H25.5776L21.9213 4.788L25.6099 10H23.551L20.7303 5.94673L19.6824 7.18395V10H17.9696Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtk);
export default __webpack_public_path__ + "static/media/rtk.58cd8ca9.svg";
export { ForwardRef as ReactComponent };